import { render, staticRenderFns } from "./overview-cell-person.vue?vue&type=template&id=1806a975&scoped=true"
import script from "./overview-cell-person.vue?vue&type=script&lang=ts"
export * from "./overview-cell-person.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1806a975",
  null
  
)

export default component.exports